import { render } from "./TenantClients.vue?vue&type=template&id=7389b28d"
import script from "./TenantClients.vue?vue&type=script&lang=js"
export * from "./TenantClients.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__